import { useSelector } from "react-redux";
import { getHighestRole } from "../util/highestRole.js";
import {
  selectCurrentRoles,
  selectCurrentToken,
} from "../features/auth/authSlice.js";
import { menuConfig } from "../components/config/menuConfig.js";

export const useMenuItems = () => {
  const token = useSelector(selectCurrentToken);
  const roles = useSelector(selectCurrentRoles);

  if (!token) return [];

  const highestRole = getHighestRole(roles);

  const menuItems = menuConfig.flatMap((item) => {
    if (!item.roles.some((role) => roles.includes(role))) return [];

    // For dynamic profile path, only generate for the highest priority role
    if (item.dynamicPath && item.basePath) {
      if (!item.roles.includes(highestRole)) return [];

      return [
        {
          ...item,
          path: `/${highestRole.toLowerCase()}/${item.basePath}`,
        },
      ];
    }

    return [item];
  });

  return menuItems;
};
